import { render, staticRenderFns } from "./logicSettings.vue?vue&type=template&id=4231c921&scoped=true&"
import script from "./logicSettings.vue?vue&type=script&lang=js&"
export * from "./logicSettings.vue?vue&type=script&lang=js&"
import style0 from "./logicSettings.vue?vue&type=style&index=0&id=4231c921&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4231c921",
  null
  
)

export default component.exports